import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "app-state-switch-custom",
  templateUrl: "./state-switch-custom.component.html",
  styleUrls: ["./state-switch-custom.component.scss"],
  standalone: true
})
export class StateSwitchCustomComponent {
  @Output() onAction = new EventEmitter<{ state: 1 | 2 }>();
  activeOption: 1 | 2 = 1;

  toggleSwitch(e: Event): void {
    e.preventDefault();
    e.stopPropagation();
    this.activeOption = this.activeOption === 1 ? 2 : 1;
    this.onAction.emit({ state: this.activeOption });
  }
}
